import FreestyleController from "components/Scene/Freestyle/Freestyle";

export enum FreestyleActionTypes {
  INIT_FREESTYLE = 'INIT_FREESTYLE',
  SET_FREESTYLE_API = 'SET_FREESTYLE_API',
  SET_ACTIVE_ITEM = 'SET_ACTIVE_ITEM',
  BUTTON_EVENT = 'FREESTY_BUTTON_EVENT',
  TOGGLE_CONTENT_OPENED = 'TOGGLE_CONTENT_OPENED',
  INCREMENT_COUNTER = 'INCREMENT_COUNTER',
  STOP_FREESTYLE = 'STOP_FREESTYLE',
}


interface InitFreestyle {
  type: FreestyleActionTypes.INIT_FREESTYLE
}

interface StopFreestyle {
  type: FreestyleActionTypes.STOP_FREESTYLE
}
interface SetFreestyleApi {
  type: FreestyleActionTypes.SET_FREESTYLE_API
  payload: FreestyleController
}

interface ToggleContentOpened {
  type: FreestyleActionTypes.TOGGLE_CONTENT_OPENED,
  payload?: boolean
}

interface SetActiveItem {
  type: FreestyleActionTypes.SET_ACTIVE_ITEM
  payload: string
}

export interface FreestyleButtonEventData {
  name?: string,
  type: 'up' | 'down' | 'move',
  greenPressed: boolean
}

interface FreestyleButtonEvent {
  type: FreestyleActionTypes.BUTTON_EVENT,
  payload: FreestyleButtonEventData
}

interface IncrementCounter {
  payload: {
    id: string,
    dir: 1 | -1,
  },
  type: FreestyleActionTypes.INCREMENT_COUNTER
}

export type FreestyleReducerActions = 
  | InitFreestyle
  | SetFreestyleApi
  | SetActiveItem
  | FreestyleButtonEvent
  | IncrementCounter
  | ToggleContentOpened
  | StopFreestyle